import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ShiftScheduleAPI from '../../api/shiftSchedule/api-shift-schedule';

export const fetchShiftSchedules = createAsyncThunk(
  'shiftSchedule/fetchShiftSchedules',
  async (_, thunkAPI) => {
    try {
      const response = await ShiftScheduleAPI.getAll();
      return response?.data?.data ?? [];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const addShiftSchedule = createAsyncThunk(
  'shiftSchedule/addShiftSchedule',
  async (payload, thunkAPI) => {
    try {
      const response = await ShiftScheduleAPI.add(payload);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const updateShiftSchedule = createAsyncThunk(
  'shiftSchedule/updateShiftSchedule',
  async (payload, thunkAPI) => {
    try {
      const response = await ShiftScheduleAPI.update(payload.id, payload);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const deleteShiftSchedule = createAsyncThunk(
  'shiftSchedule/deleteShiftSchedule',
  async (ids, thunkAPI) => {
    try {
      await ShiftScheduleAPI.delete(ids); // pass single or multiple IDs
      return ids; // return single ID or array of IDs
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// --- Initial State ---
const initialState = {
  list: [],
  loading: false,
  error: '',
};

// --- Slice ---
const shiftScheduleSlice = createSlice({
  name: 'shiftSchedule',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchShiftSchedules.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchShiftSchedules.fulfilled, (state, action) => {
        state.loading = false;
        state.list = [...action.payload];
      })
      .addCase(fetchShiftSchedules.rejected, (state, action) => {
        state.loading = false;
        state.list = [];
        state.error = action.payload ?? 'An error occurred';
      })
      .addCase(addShiftSchedule.fulfilled, (state, action) => {
        state.list.unshift(action.payload);
      })
      .addCase(updateShiftSchedule.fulfilled, (state, action) => {
        const index = state.list.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.list[index] = action.payload;
        }
      })
      .addCase(deleteShiftSchedule.fulfilled, (state, action) => {
        const idsToDelete = Array.isArray(action.payload)
          ? action.payload
          : [action.payload];

        state.list = state.list.filter(
          (item) => !idsToDelete.includes(item.id)
        );
      });
  },
});

export default shiftScheduleSlice.reducer;
